var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.show()}}},[_c('nobr',[_c('i',{staticClass:"far fa-comment-alt-lines fa-fw"}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }